<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
#main
	background:rgba(255,255,255,1);
	box-shadow:0px 0px 20px rgba(50,92,146,0.1);
	border-radius:18px;
	width:1457px;
	height:750px;
	.box
		display:flex
		height:750px
		.box-l
			width:234px
			height:750px
			background:#fff
			border-right:1px solid #eeeeee
			.box-top
				height:55px
				line-height:55px
				border-bottom:1px solid rgba(180,180,180,1)
				font-size:18px
				color:rgba(0,84,116,1)
				display:flex
				padding:0 0 0px 25px
				.l-title
					// border-bottom:1px solid rgba(180,180,180,1);
			.box-list
				height:calc(100% - 55px)
				overflow-y:auto
				.list
					width:100%
					background:#ffffff
					height:50px
					display:flex
					align-items:center
					justify-content:space-between
					font-size:14px
					cursor:pointer
					&.wait
						background:#ffffff
					&.active
						background:rgba(0,84,116,1)
						color:#ffffff
					.lists
						display:flex
						align-items:center
						img
							width:38px
							height:38px
							border-radius:50%
							margin-left:25px
						.payuser
							width:44px
							height:22px
							line-height:20px
							background:#FFECEC
							border-radius:11px
							color:#B64040
							font-size:14px
							text-align:center
							margin-left:10px
						.list-desc
							margin-left:10px
							// width:180px
							.list-name
								// width:140px
								color:#333333
								&.active
									color:#ffffff
							.list-mes
								color:#999999
								// width:140px
								overflow: hidden
								text-overflow:ellipsis
								white-space: nowrap
								&.active
									color:#ffffff
					.list-ts
						display:flex
						width:30px
						.list-wait
							color:#1890ff
							margin-right:10px
							text-align:center
							width:20px
							&.active
								color:#fff
						.list-num
							width:20px
							height:20px
							background:#ff0000
							border-radius:50%
							color:#fff
							text-align:center
							margin-right:10px
		.box-r
			min-width:950px
			// width:1325px
			.r-top
				min-width:950px
				width:1231px
				background:rgba(0,84,116,1);
				color:#ffffff
				height:55px
				display:flex
				justify-content:space-between
				align-items:center
				.top-l
					span
						margin-left:10px
						font-size:16px
				.top-r
					span
						margin-right:10px
						font-size:16px
						.el-dropdown-link
							margin-right:30px
							cursor:pointer
							color:#ffffff
							.busy
								color:#f8a562
							.free
								color:#62f869
							.el-dropdown
								color:#ffffff
			.r-main
				// width:1325px
				// min-width:950px
				display:flex
				.main-l
					width:864px
					border-right:1px solid #eeeeee
					.l-chat
						height:541px
						width:100%
						border-bottom:1px solid #eeeeee
						overflow-y:auto
						padding-top:10px
						background:#fff
						.list
							padding:0px 20px 15px 20px
							.listTime
								text-align:center
								color:#999999
								font-size:12px
								padding:5px 0
							.listwait
								display:flex
								justify-content:center
								.wait
									background:#e9ebf0
									border-radius:4px
									padding:1px 20px
									font-size:12px
									color:#999999
							.el-divider__text
								color:#cccccc
								font-size:12px !important
							.listin
								display:flex
								color:#000
								flex-direction:row-reverse
								align-items:flex-start
								.imgss
									margin-top:5px
									width:46px
									heigth:46px
									border-radius:50%
								.listbox
									padding:0 10px
									.listname
										font-size:12px
										color:#999999
										display:flex
										justify-content:flex-end
									.listmsg
										background: rgba(0,84,116,1)
										color:#ffffff
										margin-left: 14px
										padding:7px 15px
										border-radius:10px
										position: relative
										font-size:16px
										&:after
											right: -5px
											background: rgba(0,84,116,1)
											content: ''
											width: 10px
											height: 10px
											display: inline-block
											position: absolute
											top: 10px
											-webkit-transform: rotate(45deg)
											transform: rotate(45deg)
										.messageimg
											max-width:280px
											max-height:280px
											display:block
											cursor:pointer
									.listpl
										background:#eff1f6
										display:flex
										flex-direction:column
										align-items:center
										justify-content:center
										width:150px
										height:90px
										border-radius:10px
										position: relative
										&:after
											right: -5px
											background: #eff1f6
											content: ''
											width: 10px
											height: 10px
											display: inline-block
											position: absolute
											top: 10px
											-webkit-transform: rotate(45deg)
											transform: rotate(45deg)
										.plimg
											width:40px
											height:40px
									.listType
										background: #eff1f6
										margin-left: 14px
										padding:10px 15px
										border-radius:10px
										position: relative
										width:280px
										height:90px
										display:flex
										justify-content:space-between
										align-items:center
										&:after
											right: -5px
											background: #eff1f6
											content: ''
											width: 10px
											height: 10px
											display: inline-block
											position: absolute
											top: 10px
											-webkit-transform: rotate(45deg)
											transform: rotate(45deg)
										.otherfilename, .downotherfile
											color:#000
											display:inline-block
											max-width:202px
										.imgicon
											width:50px
											height:50px
											margin-right:8px
							.listout
								display:flex
								color:#fff
								align-items:flex-start
								.imgss
									margin-top:5px
									width:46px
									height:46px
									border-radius:50%
								.listbox
									padding:0 10px
									.listname
										font-size:12px
										color:#999999
									.listmsg
										background:#1890ff
										margin-right: 14px
										padding:7px 15px
										border-radius:10px
										position:relative
										font-size:16px
										&:after
											left: -5px
											background: #1890ff
											content: ''
											width: 10px
											height: 10px
											display: inline-block
											position: absolute
											top: 10px
											-webkit-transform: rotate(45deg)
											transform: rotate(45deg)
										.messageimg
											max-width:280px
											max-height:280px
											display:block
											cursor:pointer
									.listpl
										background:#eff1f6
										display:flex
										flex-direction:column
										align-items:center
										justify-content:center
										width:150px
										height:90px
										color:#000
										border-radius:10px
										position: relative
										&:after
											left: -5px
											background: #eff1f6
											content: ''
											width: 10px
											height: 10px
											display: inline-block
											position: absolute
											top: 10px
											-webkit-transform: rotate(45deg)
											transform: rotate(45deg)
										.plimg
											width:40px
											height:40px
									.listType
										background: #eff1f6
										margin-right: 14px
										padding:10px 15px
										border-radius:10px
										position: relative
										width:280px
										height:90px
										display:flex
										justify-content:space-between
										align-items:center
										color:#000
										&:after
											left: -5px
											background: #eff1f6
											content: ''
											width: 10px
											height: 10px
											display: inline-block
											position: absolute
											top: 10px
											-webkit-transform: rotate(45deg)
											transform: rotate(45deg)
										.otherfilename, .downotherfile
											color:#000
											display:inline-block
											max-width:202px
										.imgicon
											width:50px
											height:50px
											margin-right:8px
					.l-icon
						height:34px
						padding-left:20px
						line-height:35px
						width:100%
						display:flex
						border-bottom:1px solid #eeeeee
						background:#fff
						.addemojiicon
							position:relative
							i
								margin-right:20px
								font-size:20px
					.l-input
						height:120px
						padding-left:15px
						width:100%
						position: relative
						background:#fff
						.input
							width:98%
							height: 92px
							padding: 5px 10px
							white-space: pre-wrap
							word-break: break-word
							word-wrap: break-wor
							resize: none
							outline: none
							border: 0
						.info-btn
							position: absolute
							bottom:15px
							right:100px
							background:rgba(225,68,68,1)
							color:#fff
						.btn
							position: absolute
							bottom:15px
							right:15px
							background:rgba(0,82,114,1)
							color:#fff
							width:75px
				.main-r
					width:377px
					background:#ffffff
					.r-tops
						min-width:380px
						display:flex
						height:40px
						align-items:center
						border-bottom:1px solid #eeeeee
						background:#ffffff
						cursor:pointer
						.r-title
							min-width:100px
							text-align:center
							font-size:14px
							color:#666666
							padding:10px 0px
							margin:0 10px
							border-bottom:1px solid #eeeeee
							&.active
								border-bottom:1px solid #005474
								color:#005474
					.r-main
						height:655px
						width:380px
						.r-box
							width:380px
							padding:20px 20px
							height:98%
							overflow-y:auto
							.r-box-title
								font-size:16px
								font-weight:bold
								color:#333333
								margin-bottom:10px
							.r-box-info
								font-size:14px
								color:#999999
								padding:5px 0
								.info-desc
									width:250px
									color:#333
									word-wrap:break-word
									white-space:pre-wrap
							.talk
								margin-top:30px
								.talk-title
									color:#333333
									font-size:14px
									font-weight:bold
									margin:10px 10px 10px 0
								.talks
									font-size:14px
									color:#999999
									height:40px
									line-height:40px
									padding:5px 0
								.nowrap
									width:95%
									white-space:nowrap
									overflow:hidden
									text-overflow:ellipsis
									.talk-input
										width:200px
								.btns
									margin:10px 0 10px 10px
							.timeline-title
								cursor:pointer
								span
									font-weight:bold
							.timeline-list
								margin-top:10px
								.timeline-lists
									margin-bottom:5px
									.isuser
										color:#f9569f
										font-size:14px
									.iskf
										color:#4e9b52
										font-size:14px
									.isls
										color:#1890ff
										font-size:14px
									.timeline-message
										color:#999999
										font-size:14px
							.talkadd
								margin-top:10px
								.talkadd-btn
									padding:10px
							.talkbox
								display:flex
								align-items:center
								.iconfont
									font-size:25px
									color:#005474
								.talkInput
									margin-right:10px
							.talklists
								padding:10px 5px
								.talklist-mes
									display:flex
									font-size:14px
									color:#999999
									cursor:pointer
									:hover
										color:#666666
									.iconfont
										font-size:13px
										margin-left:10px
	.lawDialog
		.dialists
			height:300px
			overflow-y:auto
			padding:0 10px
			margin-top:10px
			.diaList
				display:flex
				justify-content:space-between
				align-items:center
				height:70px
				.diaMsg
					display:flex
					align-items:center
					img
						width:50px
						height:50px
						border-radius:50%
					.diaDesc
						margin-left:10px
						font-size:14px
						.dia-name
							color:#333
						.dia-kx
							color:#5ba639
						.dia-ml
							color:#f8a562
						.dia-office
							color:#999
						.dia-speciality
							span
								margin-right:10px;
								font-size:10px;
</style>
<style lang="stylus">
	.r-box
		.el-timeline-item__node--primary
			background:#005474 !important
</style>

<template>
  <div id="main">
	<div class="box">
		<div class="box-l">
			<div class="box-top">
				<div class="l-title">客户咨询（{{customer.length}}）</div>
			</div>
			<div class="box-list">
				<div v-for="(item,index) in customer" :class="{active : checkId == item.clienteleId ,wait : item.status == '1'}" class="list" @click="checkUser(item,index)">
					<div class="lists">
						<img :src="$avatarHash(item.clienteleId)" >
						<div class="list-desc">
							<div class="list-name" :class="{active : checkId == item.clienteleId }">{{item.clienteleName}}</div>
							<div class="list-mes" :class="{active : checkId == item.clienteleId }">{{item.message}}</div>
						</div>
						<div v-if="item.isPay" class="payuser">付费</div>
					</div>
					<div class="list-ts">
						<!-- <span class="list-wait" :class="{active : checkId == item.clienteleId }">{{item.wait}}s</span> -->
						<span class="list-num" v-if="item.unread_num > 0">{{item.unread_num}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="box-r">
			<div class="r-top">
				<div class="top-l">
					<span>工作统计:</span>
					<span>排队中：{{workForm.waitLength}}</span>
					<!-- <span>|</span>
					<span>新接入：{{workForm.new}}</span> -->
					<span>|</span>
					<span>正在会话中：{{customer.length}}</span>
					<span>|</span>
					<span>历史会话数：{{workForm.serveCount}}</span>
				</div>
				<div class="top-r">
					<span>客服：{{workForm.name}}</span>
					<span>|</span>
					<span>
						<el-dropdown trigger="click" @command="checkStu">
							<span class="el-dropdown-link">
								<span>状态：</span>
								<span v-if="status == '0'" class="busy">离线 ●</span>
								<span v-if="status == '1'" class="free">在线 ●</span>
								<i class="el-icon-arrow-down"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
							    <el-dropdown-item command="1">在线</el-dropdown-item>
							    <el-dropdown-item command="0">离线</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</span>
				</div>
			</div>
			<div class="r-main">
				<div class="main-l">
					<div class="l-chat" ref="messagelist">
						<div v-for="item in mesList" class="list" v-if="item.filetype != 'pay'">
						    <div v-if="item.target == 'time'" class="listTime">{{item.content}}</div>
							<div v-if="item.identity == 'support_staff' || item.identity == 'client' || item.identity == 'lawyer' " :class="item.identity == 'support_staff' ? 'listin' : 'listout'">
								<!-- <img :src="item.imgs" class="imgss"> -->
								<img v-if="item.identity == 'client' || item.identity == 'lawyer'" :src="$avatarHash(item.from)" class="imgss">
								<!-- <img v-if="item.identity == 'support_staff'" :src="$avatarHash(parseInt(list.support_staff_id))" class="imgss"> -->
								<img v-if="item.identity == 'support_staff'" src="/static/img/hxj.png" class="imgss">
								<div class="listbox">
									<!-- <div class="listname">{{item.name}}</div> -->
									<div v-if="item.identity== 'client'" class="listname">{{item.name}}</div>
									<div v-if="item.identity== 'lawyer'" class="listname">律师 {{item.name}}</div>
									<div v-if="item.identity== 'support_staff'" class="listname">弘商客服</div>
									<div v-if="!item.filetype" class="listmsg" v-html="item.content" style="white-space: pre-line; word-break: break-word; word-wrap: break-word"></div>
									<div v-else>
										<!-- 图片 -->
										<div v-if="item.filetype == 'img'" class="listmsg">
		                                    <div v-viewer="{ 'navbar': false, 'toolbar': false, 'rotatable': false, 'scalable': false, 'keyboard': true}">
		                                        <img :title="item.filename" :src="`${imgUrl}/file/preview/${item.filesrc}/img`" class="messageimg">
		                                        <!-- 将宽高设置 :height="item.imgheight" :width="item.imgwidth"宽为280px，高度适应  -->
		                                    </div>
	                                    </div>
	                                    <div v-else-if="item.filetype == 'com'" class="listpl">
	                                    	<div>
	                                    		<img v-if="item.filesrc == 10" src="/static/img/chaozan.png" class="plimg">
	                                    		<img v-else-if="item.filesrc == 5" src="/static/img/yiban.png" class="plimg">
	                                    		<img v-else-if="item.filesrc == 1" src="/static/img/cha.png" class="plimg">
	                                    	</div>
	                                    	<div>{{item.filename}}</div>
	                                    </div>
	                                    <!-- 其他文件 -->
	                                    <div v-else class="listType">
	                                    	<div>
	                                			<div v-if="item.filetype == 'doc' || item.filetype == 'ppt' || item.filetype == 'xls'"><a target="_blank" title="点击预览文件" :href="`${imgUrl}/file/preview/${item.filesrc}`" class="otherfilename single_ellipsis">{{item.filename}}</a></div>
	                                			<div v-else>{{item.filename}}</div>
	                                			<div style="margin-top:5px"><a target="_blank" title="下载此文件" :href="`${imgUrl}/file/download/${item.filesrc}`" class="downotherfile" style="color:#999;font-size:12px">下载</a></div>
	                                		</div>
	                                		<div>
	                                			<img :src="`/static/img/format/${item.filetype}.jpg`" class="imgicon">
	                                		</div>
	                                    </div>
									</div>
								</div>
							</div>
							<div v-if="item.target == 'wait'" class="listwait">
								<div class="wait">{{item.msg}}</div>
							</div>
							<div v-if="item.target == 'history'" class="listhistory">
								<el-divider>以上为历史信息</el-divider>
							</div>
						</div>
					</div>
					<div class="l-icon" v-if="clientele_id">
						<div @click.self="isshowEmoji = !isshowEmoji" title="发送表情" class="addemojiicon" style="cursor:pointer">
							<i class="iconfont iconbiaoqing" @click.self="isshowEmoji = !isshowEmoji" ></i>
							<z_emoji
		                        ref="emojiwrap"
		                        v-show="isshowEmoji"
		                        @toggleshowEmoji="isshowEmoji = !isshowEmoji"
		                        :currentSay="message"
		                        @changecurrentSay="changeCurrentSayEmoji">
		                    </z_emoji>
	                    </div>
	                    <!-- 暂时不做文件的发送 -->
	                    <div class="addemojiicon" title="发送图片" style="cursor:pointer">
	                    	<z_fileUpload
	                            :params="fileup_param"
	                            @fileUpSuccess="fileUpSuccess"
	                            @fileUpError="fileUpError"
	                            ref="messagefileup">
	                            <i class="iconfont iconicon_photo" slot="icon"></i>
	                        </z_fileUpload>
	                    </div>
						
						<div class="addemojiicon" title="选择文件" style="cursor:pointer">
							<z_fileUpload
	                            :params="fileup_param"
	                            @fileUpSuccess="fileUpSuccess"
	                            @fileUpError="fileUpError"
	                            ref="messagefileup">
	                            <i class="iconfont iconicon_workfile_line" slot="icon"></i>
	                        </z_fileUpload>
						</div>
						<div class="addemojiicon" title="邀请律师" @click="showLawyer" style="cursor:pointer"><i class="iconfont iconicon_addperson"></i></div>
						<div class="addemojiicon" title="邀请评价" @click="showPl" style="cursor:pointer"><i class="iconfont iconicon_likegood"></i></div>
						<div class="addemojiicon" title="邀请付费" @click="showPay" style="cursor:pointer"><i class="iconfont iconqian"></i></div>
					</div>
					<div class="l-icon" v-else>
						<div class="addemojiicon"><i class="iconfont iconbiaoqing"></i></div>
						<div class="addemojiicon"><i class="iconfont iconicon_photo"></i></div>
						<div class="addemojiicon"><i class="iconfont iconicon_workfile_line"></i></div>
						<div class="addemojiicon"><i class="iconfont iconicon_addperson"></i></div>
						<div class="addemojiicon"><i class="iconfont iconicon_likegood"></i></div>
						<div class="addemojiicon"><i class="iconfont iconqian"></i></div>
					</div>
					<div class="l-input">
						<textarea v-if="clientele_id" class="input" placeholder="输入您的问题" v-model="message" :maxlength="1000" @keydown.ctrl.enter="lineFeed" @keydown.enter.exact="send" ref="textarea"></textarea>
						<el-button class="info-btn" size="small" type="info" icon="el-icon-switch-button" round @click="overChat">关闭</el-button>
						<el-button class="btn" size="small" type="primary" icon="el-icon-s-promotion" round @click="send">发 送</el-button>
					</div>
				</div>
				<div class="main-r">
					<div class="r-tops">
						<div class="r-title" :class="{active : checknum == '1' }" @click="checkNum(1)">客户信息</div>
						<div class="r-title" :class="{active : checknum == '2' }" @click="checkNum(2)">互动记录</div>
						<div class="r-title" :class="{active : checknum == '3' }" @click="checkNum(3)">常用话术</div>
					</div>
					<div class="r-main">
						<div v-if="checknum == '1'" class="r-box">
							<div class="r-box-title">基本信息</div>
							<div class="r-box-info">
								<span class="info-name">用&nbsp;&nbsp;户&nbsp;&nbsp;名：</span>
								<span class="info-desc">{{infoForm.nickname}}</span>
							</div>
							<div class="r-box-info">
								<span class="info-name">手&nbsp;&nbsp;机&nbsp;&nbsp;号：</span>
								<span class="info-desc">{{infoForm.phone}}</span>
							</div>
							<div class="r-box-info">
								<span class="info-name">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;域：</span>
								<span class="info-desc">{{list.address}}</span>
							</div>
							<div class="r-box-info">
								<span class="info-name">会话时长：</span>
								<span class="info-desc">{{infoForm.all_consult_use_time | formatSeconds}}</span>
							</div>
							<div class="r-box-info">
								<span class="info-name">来访次数：</span>
								<span class="info-desc">{{infoForm.consult_count}}</span>
							</div>
							<div class="r-box-info" style="display:flex">
								<span class="info-name">来源网址：</span>
								<span class="info-desc">{{list.visitUrl}}</span>
							</div>

							<div class="talk">
								<div class="r-box-title">采集信息</div>
								<div class="r-box-info">
									<span class="info-name">公司名称：</span>
									<span class="info-desc">{{consultFormInfo.company_name || nomes}}</span>
								</div>
								<div class="r-box-info">
									<span class="info-name">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
									<span class="info-desc">{{consultFormInfo.consult_name || nomes}}</span>
								</div>
								<div class="r-box-info">
									<span class="info-name">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务：</span>
									<span class="info-desc">{{consultFormInfo.position || nomes}}</span>
								</div>
								<div class="r-box-info">
									<span class="info-name">手&nbsp;&nbsp;机&nbsp;&nbsp;号：</span>
									<span class="info-desc">{{consultFormInfo.contact_phone || nomes}}</span>
								</div>
								<div class="r-box-info">
									<span class="info-name">所在园区：</span>
									<span class="info-desc">{{consultFormInfo.address || nomes}}</span>
								</div>
								<div class="r-box-info">
									<span class="info-name">关注问题：</span>
									<span class="info-desc" v-if="consultFormInfo.consult_tag_id" v-for="(item , i) in consultFormInfo.consult_tag_id">
										<span style="margin-right:5px">{{item | consultFormInfoTag(tagsList)}}</span>
										<span v-if="consultFormInfo.consult_tag_id.length != i+1">、</span>
									</span>
									<span v-if="!consultFormInfo.consult_tag_id"  class="info-desc">未填写</span>
								</div>
							</div>

							<div class="talk">
								<div>
									<span class="talk-title">咨询总结</span>
									<i class="iconfont iconbi" @click="showConsultEdit" v-if="clientele_id" style="cursor:pointer"></i>
								</div>
								<div class="talks nowrap">
									<span class="talk-name">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
									<span v-if="!showZxEdit" style="color:#333">{{infoForm.name || nomes}}</span>
									<span v-if="showZxEdit">
										<el-input v-model="talkform.name" size="mini" class="talk-input"></el-input>
									</span>
								</div>
								<div class="talks nowrap">
									<span class="talk-name">公司名称：</span>
									<span v-if="!showZxEdit" style="color:#333">{{infoForm.company || nomes}}</span>
									<span v-if="showZxEdit">
										<el-input v-model="talkform.company" size="mini" class="talk-input"></el-input>
									</span>
								</div>
								<div class="talks nowrap">
									<span class="talk-name">公司地址：</span>
									<span v-if="!showZxEdit" style="color:#333">{{infoForm.address || nomes}}</span>
									<span v-if="showZxEdit">
										<el-input v-model="talkform.address" size="mini" class="talk-input"></el-input>
									</span>
								</div>
								<div class="talks nowrap">
									<span class="talk-name">联系方式：</span>
									<span v-if="!showZxEdit" style="color:#333">{{infoForm.phone || nomes}}</span>
									<span v-if="showZxEdit">
										<el-input v-model="talkform.phone" size="mini" class="talk-input"></el-input>
									</span>
								</div>
								<div class="talks nowrap">
									<span class="talk-name">用户等级：</span>
									<span v-if="!showZxEdit" style="color:#333">{{infoForm.grade || nomes}}</span>
									<span v-if="showZxEdit">
										<el-input v-model="talkform.grade" size="mini" class="talk-input"></el-input>
									</span>
								</div>
								<div class="talks nowrap" style="display:flex">
									<div class="talk-name">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</div>
									<div v-if="!showZxEdit" style="color:#333">{{infoForm.remark || nomes}}</div>
									<div v-if="showZxEdit">
										<el-input v-model="talkform.remark" size="mini" class="talk-input"></el-input>
									</div>
								</div>
								<div  v-if="showZxEdit" class="btns">
									<el-button type="primary" size="mini" round @click="subZxEdit">保存</el-button>
									<el-button type="info" size="mini" round @click="notZxEdit">取消</el-button>
								</div>
							</div>
						</div>
						<div v-if="checknum == '2'" class="r-box">
							<div>
								<el-timeline>
									<el-timeline-item v-if="recordList.length == 0">暂时没有记录哦</el-timeline-item>
									<el-timeline-item v-if="recordList" v-for="(item , index) in recordList" :key="index" type="primary">
										<p @click="checkRecord(item.record_id,index)" class="timeline-title"><span>客服{{item.support_staff}}</span>&nbsp;&nbsp;&nbsp;{{item.begin_time | timeconvert}}&nbsp;&nbsp;&nbsp;时长：{{item.use_time | formatSeconds}}</p>
									    <div v-if="recordId == index" class="timeline-list">
											<div v-for="(item , i) in messageList" class="timeline-lists">
												<div :class="{'isuser' : item.identity == 'client','iskf' : item.identity == 'support_staff','isls' : item.identity == 'lawyer',}">
													<span v-if="item.identity == 'client'">{{item.name}}</span>
													<span v-if="item.identity == 'lawyer'">律师 {{item.name}}</span>
													<span v-if="item.identity == 'support_staff'">客服{{item.from}}</span>
													&nbsp;&nbsp;&nbsp;{{item.time | timeconvert1}}</div>
												<div v-if="item.filetype">
													<div v-if="item.filetype == 'img'">
														<div v-viewer="{ 'navbar': false, 'toolbar': false, 'rotatable': false, 'scalable': false, 'keyboard': true}">
					                                        <img :title="item.filename" :src="`${imgUrl}/file/preview/${item.filesrc}/img`" style="max-width:220px;max-height:220px;display:block;cursor:pointer;">
					                                        <!-- 将宽高设置 :height="item.imgheight" :width="item.imgwidth"宽为280px，高度适应  -->
					                                    </div>
													</div>
													<div v-else-if="item.filetype == 'com'" style="background:#f0f0f0;padding:2px 0;max-width:100px;border-radius:5px;text-align:center;">{{item.filename}}</div>
													<div v-else-if="item.filetype == 'pay'" style="background:#f0f0f0;padding:2px 0;max-width:150px;border-radius:5px;text-align:center;">客服发起咨询付费邀请</div>
													<div v-else>
														<a v-if="item.filetype == 'doc' || item.filetype == 'ppt' || item.filetype == 'xls'" style="color:#000" target="_blank" title="点击预览文件" :href="`${imgUrl}/file/preview/${item.filesrc}`">{{item.filename}}</a>
														<span v-else style="color:#000">{{item.filename}}</span>
														<a style="color:#000" target="_blank" title="下载此文件" :href="`${imgUrl}/file/download/${item.filesrc}`">下载</a>
													</div>
												</div>
												<div v-else class="timeline-message" v-html="item.content"></div>
											</div>
										</div>
									</el-timeline-item>
								</el-timeline>
							</div>
						</div>
						<div v-if="checknum == '3'" class="r-box">
							<div class="talkbox">
								<el-input v-model="talkSearch" clearable size="mini" prefix-icon="el-icon-search" class="talkInput"></el-input>
								<i class="iconfont iconicon_roundadd_fill" @click="showAdd = !showAdd"></i>
							</div>
							<div class="talkadd" v-if="showAdd">
								<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入" v-model="talkAdd"></el-input>
								<div class="talkadd-btn">
									<el-button size="mini" round type="info" @click="addTalkNot">取 消</el-button>
									<el-button size="mini" round style="background:#005474;color:#fff;" @click="addTalk">保 存</el-button>
								</div>
							</div>
							<div>
								<div v-for="(item , index) in talkList" class="talklists">
									<div  @mouseenter="onTalk(index)" @mouseleave="outTalk(index)" v-if="!showEdit || editNum != index" class="talklist-mes" @dblclick="talkInMessage(item.content)">
										<div>{{index+1}}、</div>
										<div>
											<span>{{item.content}}</span>
											<i class="iconfont iconbi" v-if="showTalk && talkNum == index" @click="showEdits(index,item)"></i>
											<i class="iconfont iconicon_delete_fill" v-if="showTalk && talkNum == index" @click="delTalkList(item.id)"></i>
										</div>
									</div>
									<div class="talkadd" v-if="showEdit && editNum == index">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入" v-model="talkEdit"></el-input>
										<div class="talkadd-btn">
											<el-button size="mini" round type="primary" @click="editTalkList(item)">保 存</el-button>
											<el-button size="mini" round type="info" @click="editTalkListNot">取 消</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<el-col>
		<el-dialog title="律师" :visible.sync="isLawyer" width="400px" class="lawDialog">
  			<div>
  				<el-input size="small" placeholder="输入律师名称搜索" v-model="searchUser" @keyup.enter.native="searchuser" clearable>
					<el-button size="small" slot="append" icon="el-icon-search" @click="searchuser"></el-button>
				</el-input>
  			</div>
  			<div class="dialists">
	  			<div v-for="(item , index) in lawyerList" class="diaList">
	  				<div class="diaMsg">
	  					<div>
	  						<img :src="$avatarHash(item.id)">
	  					</div>
	  					<div class="diaDesc">
	  						<div>
	  							<span class="dia-name">{{item.name}}</span>
	  							<!-- <span v-if="item.status == '0'" class="dia-kx">空闲</span> -->
	  							<!-- <span v-if="item.status == '1'" class="dia-ml">忙碌</span> -->
	  						</div>
	  						<div class="dia-office">{{item.company}}</div>
	  						<div class="dia-speciality">
	  							<span v-for="items in item.speciality">{{items}}</span>
	  						</div>
	  					</div>
	  				</div>
  					<div v-if="lawyer_id">
  						<div v-if="lawyer_id == item.id">
  							<el-button disabled size="mini" type="success" round>已加入</el-button>
  						</div>
  						<div v-else>
  							<el-button disabled size="mini" type="primary" round>邀请</el-button>
  						</div>
  					</div>
  					<div v-else>
  						<div v-if="waitLawyer">
  							<div v-if="waitLawyer == item.id">
  								<el-button disabled size="mini" type="danger" round>待接入</el-button>
  							</div>
  							<div v-else>
  								<el-button disabled size="mini" type="primary" round>邀请</el-button>
  							</div>
  						</div>
  						<div v-else>
  							<el-button size="mini" type="primary" round @click="inviteLaw(item.id)">邀请</el-button>
  						</div>
  					</div>
	  			</div>
  			</div>
  		</el-dialog>
	</el-col>
  </div>
</template>

<script>
import z_emoji from '@/components/common/z-emoji';
import {messageConvert} from '@/common/js/messageConvert';
import z_fileUpload from '@/components/common/z-fileUpload';
import moment from 'moment';
export default {
	data() {
		return {
			imgUrl,
			messageConvert,
			customer:[],
			checkId:'',
			status:'',
			workForm:{
				wait:'',
				new:'',
				talking:'',
				allTalk:'',
				name:''
			},
			list:[],
			mesList:[],
			isshowEmoji:false,  //显示表情
			isLawyer:false,  //显示律师
			message:'',  //聊天消息
			checknum:'1',    //选择信息
			recordList:[],  //时间线互动会话列表
			messageList:[],  //互动会话消息详情
			recordId:'-1',  //显示互动会话
			showZxEdit:false,
			infoForm:{},
			regin:'',  //地域
			nomes:'未填写',
			talkform:{
				name:'',
				company:'',
				address:'',
				phone:'',
				grade:'',
				remark:''
			},
			talkSearch:'',  //常用话术搜索
			talkAdd:'',
			showAdd:false,
			showEdit:false,
			talkEdit:'',
			editNum:'-1',
			talkList:[],
			showTalk:false,  //显示常用话术的编辑删除
			talkNum:'-1',
			lawyerList:[],
			searchUser:'',
			clock:[],
			support_staff:'',  //工号
			clientele_id:'',  //服务的客户id
			lawyer_id:'',
			numList : [], //未读消息数列表
			waitLawyer:'', //待接入的律师id
			timer3:'',  //每30秒获取一次客服工作统计
			timer4:'',  //对话超过两分钟的计时器
			newTime:false,  //对是否话超出2分钟
			num:'',
			consultFormInfo:{},  //客户咨询采集信息数据
			tagsList:[]  //采集信息中关注问题的列表
		}
	},
	computed: {
		fileup_param() {
            return {
                // 'about_type': 'chats',
                // 'about_id': this.$store.state.mineInfo.id
                'about_type': 'consult',
                'about_id': '0',
                'cid': '0'
            }
        },
        consultChat() {
            return this.$store.state.consultChat;
        },
    },
	created() {
		this.support_staff = this.$store.state.mineInfo.isSupportStaff;
	},
	mounted() {
		this.getServeList();
		// this.getChatList();
		this.getTalkList();
		// this.getConsultrecord();
		this.getWorkStatistics();
		// this.getRecordList();
		this.getStatus();
		this.getTags();  //获取关注问题列表
		// this.timer3=setInterval(() =>{
		// 	// clearInterval(this.timer3);
		// 	this.getWorkStatistics();
		// },30*1000);
		this.timer4=setInterval(() =>{
			this.newTime = true;
			// clearInterval(this.timer3);
			console.log('jishiqi',this.newTime);
		},2*60*1000);
	},
	methods: {
		//咨询付费邀请
		showPay(){
			this.$prompt('请输入金额', '提示', {
	          confirmButtonText: '确定',
	          cancelButtonText: '取消'
	        }).then(({ value }) => {
	        	if(value == '' || value == null){
	        		this.$message.error('请输入金额！');
	        	}else{
	        		this.num = value;
	        		let data={
	        			to:this.clientele_id,
	        			fee:value
	        		};
	        		let url = 'consultcenter/invatePay';
	        		this.$ajax('post',url,data,res=>{
	        			if(res.retcode === 0){
	        				console.log('11111res',res);
	        				let obj = {
	        					hash: res.payconsult_id,
					            name: this.num + ';;' + res.order_sn,
					            ext:'pay'
	        				};
	        				obj = messageConvert(obj, "encode");
	        				console.log('1111obj',obj);
            				this.sendMsg(obj,true);
            				this.scrollToBottom();
	        				this.$message({
					            type: 'success',
					            message: '发起付费邀请成功！'
					        });
	        			}
	        		});
	        	}
	        }).catch(() => {
	          this.$message({
	            type: 'info',
	            message: '取消付费邀请'
	          });       
	        });
		},
		//关闭会话
		overChat(){
			if(!this.clientele_id){
				this.$message({
		            type: 'error',
		            message: '当前没有用户'
		          }); 
			}else{
				this.$confirm('是否结束该对话？确定后本次会话将结束。', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		        	let url ='consultcenter/closePayconsult';
		        	let obj = {
		        		to:this.clientele_id
		        	};
		        	if(this.lawyer_id){
		        		obj.lawyer_id = this.lawyer_id;
		        	}
		        	this.$ajax('post',url , obj,res=>{
		        		if(res.retcode === 0){
		        			this.$message({
					            type: 'success',
					            message: '关闭会话成功！'
					        });
		        		}else{
		        			this.$message.error(res.data.errmsg)
		        		}
		        	})
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消关闭会话'
		          });          
		        });
			}
		},
		//客服当前状态
		getStatus(){
			let url = 'consultcenter/supportstaffmanage/selfstatus';
			this.$ajax('get' , url , res=>{
				if(res.retcode === 0){
					this.status = res.status;
				}
			})
		},
		//客服当前服务列表
		getServeList(){
			let url = 'consultcenter/supportstaffmanage/servelist';
			this.$ajax('get' , url  , res => {
				if (res.retcode === 0) {
		        	// console.log('客服当前服务列表',res.data);
		        	for(var i =0;i<res.data.length;i++){
		        		res.data[i].num = 0;
		        	};
		        	this.customer = res.data;
		        	if(!this.customer.length){
		        		console.log('无服务列表');
		        		this.clientele_id = '';
		        		this.recordList = [];
		        		this.infoForm = {};
		        	}else{
		        		let newnumList = [];
			        	for(var i=0;i<this.customer.length;i++){
			        		for(var j=0;j<this.numList.length;j++){
			        			if(this.customer[i].clienteleId == this.numList[j].clienteleId){
			        				this.customer[i].num = this.numList[j].num;
			        				newnumList.push(this.numList[j]);
			        				break;
			        			}
			        		}
			        	}
			        	this.numList = newnumList;
		        		if(this.clientele_id == ''){
		        			this.mesList = [];
		        			this.clientele_id = res.data[0].clienteleId;
		        			this.checkId = res.data[0].clienteleId;
		        			this.getRecordList();
							this.getConsultrecord();
							this.getConsultFormInfo();
							this.getChatList();
		        		}else{
		        			var idlist = [];
		        			for(var j=0;j<this.customer.length;j++){
		        				idlist.push(this.customer[j].clienteleId);
		        			};
		        			if(idlist.indexOf(this.clientele_id) == -1){
		        				this.mesList = [];
		        				this.clientele_id = res.data[0].clienteleId;
		        				this.checkId = res.data[0].clienteleId;
		        				this.getRecordList();
								this.getConsultrecord();
								this.getConsultFormInfo();
								this.getChatList();
		        			}
		        		}
		    //     		this.getRecordList();
						// this.getConsultrecord();
						// this.getConsultFormInfo();
						// this.getChatList();
		        	}
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//获取客户咨询记录列表
		getRecordList(){
			let url = 'consultcenter/clientele/consultrecordlist';
			let params = {
				clientele_id:this.clientele_id,
				is_lawyer:0
			};
			this.$ajax('get' , url , params , res => {
				if (res.retcode === 0) {
		        	// console.log('客户咨询记录列表',res.data);
		        	this.recordList = res.data;
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//获取客户咨询记录详情
		getRecordInfo(id){
			let url = 'consultcenter/clientele/consultrecord';
			let params = {
				record_id:id,
			};
			this.$ajax('get' , url , params , res => {
				if (res.retcode === 0) {
		        	let list = res.data[0].consult_content;
		        	this.messageList = list.replace(/},/g,"},,").split(",,")
		        	for(var i=0;i<this.messageList.length;i++){
		        		this.messageList[i]=messageConvert(JSON.parse(this.messageList[i]))
		        	}
		        	this.messageList = this.timeSort(this.messageList,'time');
		        	// console.log(this.messageList);
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//打开编辑客户信息（咨询总结）
		showConsultEdit(){
			this.showZxEdit = true;
			this.talkform = {
				name:this.infoForm.name || '',
				company:this.infoForm.company || '',
				address:this.infoForm.address || '',
				phone:this.infoForm.phone || '',
				grade:this.infoForm.grade || '',
				remark:this.infoForm.remark || ''
			};
		},
		//编辑客户信息（咨询总结）
		subZxEdit(){
			let url='consultcenter/clientele/setinformation';
			let params = this.talkform;
			params.clientele_id = this.clientele_id;
			this.$ajax('post' , url , params, res => {
				if (res.retcode === 0) {
		        	this.$message.success('编辑客户信息成功!');
		        	this.getConsultrecord();
		        	this.showZxEdit = false;
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//取消编辑客户信息（咨询总结）
		notZxEdit(){
			this.showZxEdit = false;
		},
		//客服工作统计
		getWorkStatistics(){
			let url = 'consultcenter/supportstaffmanage/jobaccount';
			this.$ajax('get' , url ,  res => {
				if (res.retcode === 0) {
		        	this.workForm = res.data;
		        	this.workForm.name = this.support_staff;
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//获取地理位置
		getuserip() {
	      let defaultlocation = ['广东省', '深圳市'];
	      this.$ajax('get', 'getip', data => {
	        if( data.ip_province !== '' && data.ip_city !== '' ){
	        	this.regin = data.ip_province +'/' + data.ip_city;
	        	console.log(this.regin)
	        }
	      }, err => {

	      });
	    },
		//获取客户信息
		getConsultrecord(){
			let url = 'consultcenter/clientele/getinformation';
			let params = {
				clientele_id:this.clientele_id
			}
			this.$ajax('get' , url , params, res => {
				if (res.retcode === 0) {
		        	// console.log('1111111111',res.data)
		        	if(res.data == null){
		        		this.infoForm = {}
		        	}else{
		        		this.infoForm = res.data;
		        	}
		        	// this.getuserip();
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//获取客户咨询采集信息
		getConsultFormInfo(){
			let url = 'wxm/consult/show';
			let params = {
				userid:this.clientele_id
			};
			this.$ajax('get',url,params,res => {
				if(res.retcode === 0){
					if(res.data){
						this.consultFormInfo = res.data;
						this.consultFormInfo.consult_tag_id  = this.consultFormInfo.consult_tag_id.split(",");
					}else{
						this.consultFormInfo = []
					}
				}
			})
		},
		//获取咨询采集信息里面关注问题列表
		getTags(){
			let url = 'wxm/consult/getTags';
			this.$ajax('get',url,res => {
				if(res.retcode === 0){
					this.tagsList = res.data;
				}
			})
		},
		//发送消息到后台
		sendMsg(obj,isupload){
			let url='consultcenter/sendchat';
			let users = [];
			users.push(this.clientele_id);
			if(this.lawyer_id){
				users.push(this.lawyer_id);
			}
			let params = {};
			if(isupload){
				params = {
					to:users,
					content:obj.content,
					is_client:0
				}
			}else{
				params = {
					to:users,
					content:this.message,
					is_client:0
				}
			}
			this.$ajax('post' , url , params, res => {
				if (res.retcode === 0) {
		        	// console.log('1111111111',res.data)
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//给对话列表按时间排序
		timeSort(array,key){
			return array.sort(function(a,b){
		     var x = a[key];
		     var y = b[key];
		     return ((x<y)?-1:(x>y)?1:0)
		    })
		},
		//获取对话列表
		getChatList(){
		    let url = 'consultcenter/getchatcontent'
		    let params = {
		        // client_id: this.$store.state.mineInfo.id
		        client_id:this.clientele_id
		    }
		    this.$ajax('get', url, params, res => {
		        if (res.retcode === 0) {
		        	this.readMsg();
		          	// console.log('对话',res.data);
		          	if(res.data.content_list){
		          		let v = this.timeSort(res.data.content_list,'time');
	                    let temparr = [];
	                    if( v.length ){
	                        let temptime;
	                        v.forEach(e => {
	                            // 添加聊天时间
	                            if( !temptime || (e.time - temptime >= 300) ){
	                                let obj = {
	                                    content: this.timeconvert2(e.time * 1000),
	                                    target: "time",
	                                    time: e.time*1000
	                                };
	                                temparr.push(obj);
	                                temptime = e.time;
	                            }
	                            // 进行信息替换并插入缓存数组
	                            temparr.push(messageConvert(e));
	                        });
	                    }
	                    this.mesList = temparr.concat(this.mesList);
			          	// this.mesList = res.data.content_list.reverse();
			          	this.list = res.data;
			          	this.lawyer_id = res.data.lawyer_id;
			          	this.scrollToBottom();
			          	// console.log('mesList',this.mesList);
			          }else{
			          	console.log('没有数据')
			          }
		        }else{
		        	this.$message.error(res.data.errmsg)
		        }
		    });
		},
		//获取在线律师列表
		getlawyerList(){
		    let url = 'consultcenter/lawyer/onlinelist'
		    this.$ajax('get', url, res => {
		        if (res.retcode === 0) {
		          // console.log('律师列表',res.data)
		          this.lawyerList = res.data;
		        } 
		    })
		},
		//选择用户
		checkUser(item,i){
			this.checkId = item.clienteleId;
			this.clientele_id = item.clienteleId;
			this.recordId = '-1';
			this.customer[i].unread_num = 0;
			this.customer[i].num = 0;
			for(var i=0;i<this.numList.length;i++){
				if(this.numList[i].clienteleId == item.clienteleId){
					this.numList[i].num = 0;
				}
			}
			this.mesList = [];
			this.getRecordList();
			this.getConsultrecord();
			this.getChatList();
			this.getConsultFormInfo();
		},
		//咨询消息已读
		readMsg(){
			let url = 'consultcenter/setRead';
			let params = {
				client_id:this.clientele_id
			};
			this.$ajax('get' , url ,params,res=>{
				
			})
		},
		//修改状态
		checkStu(command){
			this.status = command;
			let url = 'consultcenter/supportstaffmanage/edit';
			let option = {
				job_number:this.support_staff,
				status:this.status,
				user_id:this.$store.state.mineInfo.id
			};
			this.$ajax('post',url,option,res => {
				if(res.retcode === RETCODE_OK){
					this.$message({
			          message: '修改状态成功！',
			          type: 'success'
			        });
				}else{
					this.$message.error(res.data.errmsg)
				}
			})
		},
		// 发消息或来消息滚动到底部
        scrollToBottom() {
            this.$nextTick(() => {
                if( this.$refs.messagelist ){
                    this.$refs.messagelist.scrollTop = this.$refs.messagelist.scrollHeight;
                }
            });
        },
        //选中表情
        changeCurrentSayEmoji(v) {
            this.message = v;
            this.$refs.textarea.focus();
        },
        //ctrl+enter的换行处理
        lineFeed(){
        	this.message = this.message + '\n';
        },
        //发送消息
        send(event){
        	let obj = {
        		identity: 'support_staff',
        		content:this.message,
        		// imgs:'/static/img/anonymity.png',
        		// name:'用户007'
        	};
        	obj = messageConvert(obj);
        	if(this.message == ''){
        		this.$Message.error('请输入内容后再发送消息！');
        		event.preventDefault();
        	}else{
        		this.sendMsg();
        		if(this.newTime){
        			var myDate = new Date();
        			var options={
        				content: this.timeconvert2(myDate.getTime()),
                        target: "time",
        			}
        			this.mesList.push(options);
        			this.newTime = false;
        		}
        		this.mesList.push(obj);
	        	event.preventDefault();
	        	this.message = '';
	        	this.scrollToBottom();
        	}
        	
        },
        //右边互动栏的切换
        checkNum(num){
			this.checknum = num;
		},
		//时间线对话展开
		checkRecord(id,i){
			if(i == this.recordId){
				this.recordId = '-1';
				this.messageList = [];
			}else{
				this.recordId = i;
				this.getRecordInfo(id);
			}
		},
		//鼠标接触常用话术列表显示
		onTalk(i){
			this.showTalk = true;
			this.talkNum = i;
		},
		//鼠标不接触隐藏
		outTalk(i){
			this.showTalk = false;
			this.talkNum = '-1';
		},
		//双击常用话术，添加到会话框
		talkInMessage(mes){
			this.message = this.message + mes;
			//获取焦距
			this.$refs.textarea.focus();
		},
		//显示编辑常用话术框
		showEdits(i,item){
			this.showEdit = true;
			this.talkEdit = item.content;
			this.editNum = i;
		},
		//编辑常用话术提交
		editTalkList(item){
			let url = 'consultcenter/editcommonstatement';
			let params = {
				content:this.talkEdit,
				id:item.id
			}
			this.$ajax('post' , url , params, res => {
				if (res.retcode === 0) {
		        	this.showEdit = false;
		        	this.$message.success('编辑常用话术成功！');
		        	this.getTalkList();
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//编辑常用话术取消
		editTalkListNot(){
			this.showEdit = false;
		},
		//删除常用话术
		delTalkList(id){
			this.$confirm('是否删除该常用话术？', '提示', {
	          confirmButtonText: '确定',
	          cancelButtonText: '取消',
	          type: 'warning'
	        }).then(() => {
	        	let url = 'consultcenter/delcommonstatement';
				let params = {
					id:id
				}
				this.$ajax('post' , url , params, res => {
					if (res.retcode === 0) {
			        	this.$message.success('删除常用话术成功！')
			        	this.getTalkList();
			        } else {
			          this.$message.error(res.data.errmsg)
			        }
				})
	        }).catch(() => {
	          this.$message({
	            type: 'info',
	            message: '已取消删除'
	          });          
	        });
		},
		//添加常用话术
		addTalk(){
			let url = 'consultcenter/addcommonstatement';
			let params = {
				content:this.talkAdd
			}
			this.$ajax('post' , url , params, res => {
				if (res.retcode === 0) {
		        	this.showAdd = false;
		        	this.talkAdd = '';
		        	this.$message.success('添加常用话术成功！');
		        	this.getTalkList();
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//取消添加常用话术
		addTalkNot(){
			this.showAdd = false;
		    this.talkAdd = '';
		},
		//获取常用话术
		getTalkList(){
			let url ='consultcenter/getcommonstatement';
			this.$ajax('get' , url , res=>{
				if(res.retcode === 0){
					this.talkList = res.data;
				}else{
					this.$message.error(res.data.errmsg)
				}
			})
		},
		//上传成功
        fileUpSuccess(response, file, fileList, params) {
            if( !response.hash ){
                this.$Message.error('服务器错误！上传失败！');
                return false;
            }
            file.name = file.name || "image.png";
            let obj = {
                name: file.name,
                hash: response.hash,
                ext: file.name.substr( file.name.lastIndexOf(".")+1 ).toLowerCase(),
                width: params.imgwidth,
                height: params.imgheight,
                touid: params.about_id
            };
            obj = messageConvert(obj, "encode");
            this.sendMsg(obj,true);
            let inmessage = {content: obj.content,identity: 'support_staff', time: moment().format("YYYY-MM-DD HH:mm:ss")};
            inmessage = Object.assign(inmessage, obj);
            this.mesList.push(inmessage);
            this.scrollToBottom();
        },
        //上传失败
        fileUpError(error, file, fileList, params) {
        	this.$message.error('上传失败，请重新上传！')
            console.log(error, file, fileList, params);
        },
		//邀请客户评论
		showPl(){
			this.$confirm('是否邀请客户为当前服务评论？', '提示', {
	          confirmButtonText: '确定',
	          cancelButtonText: '取消',
	          type: 'warning'
	        }).then(() => {
	        	let url ='consultcenter/clientele/sendfeedscore';
	        	let obj = {
	        		to_id:this.clientele_id
	        	};
	        	this.$ajax('get',url , obj,res=>{
	        		if(res.retcode === 0){
	        			let objs = {
	                		target :'wait',
	                		msg:'已邀请客户为本次咨询评价！'
	                	};
	                	this.mesList.push(objs);
	                	this.scrollToBottom();
	        			this.$message({
				            type: 'success',
				            message: '邀请成功!'
				        });
	        		}else{
	        			this.$message.error(res.data.errmsg)
	        		}
	        	})
	        }).catch(() => {
	          this.$message({
	            type: 'info',
	            message: '已取消邀请'
	          });          
	        });
		},
		//邀请律师显示
		showLawyer(){
			this.isLawyer = true;
			this.getwaitList();
			this.getlawyerList();
		},
		//获取待接入律师的id
		getwaitList(){
			let url ='consultcenter/waitlawyer';
			let obj = {
				client_id:this.clientele_id
			};
			this.$ajax('get' , url , obj,res=>{
				if(res.retcode === 0){
					this.waitLawyer = res.lawyer_id;
				}else{
					this.$message.error(res.data.errmsg)
				}
			})
		},
		//邀请律师
		inviteLaw(law_id){
			let url='consultcenter/invitelawyer';
			let params = {
				client_id:this.clientele_id,
				lawyer_id:law_id
			}
			this.$ajax('post' , url , params, res => {
				if (res.retcode === 0) {
		        	this.isLawyer = false;
		        	this.$message.success('邀请成功!');
		        	let objs = {
                		target :'wait',
                		msg:'平台正在为您匹配律师'
                	};
                	this.mesList.push(objs);
                	this.scrollToBottom();
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//搜索律师
		searchuser(){
			if(this.searchUser != ''){
				this.lawyerList = this.lawyerList.filter(e => e.name.includes(this.searchUser));
			}else{
				this.getlawyerList();
			}
		},
		//时间转换
        timeconvert2(date) {
            if( moment().isSame(date, 'day') ){
                return moment(date).format('HH:mm:ss');
            }else{
                return moment(date).format('YYYY-MM-DD HH:mm:ss');
            }
        },
	},
	watch: {
		talkSearch(v,ov){
			if(v != ''){
				this.talkList = this.talkList.filter(e => e.content.includes(this.talkSearch));
			}else{
				this.getTalkList();
			}
		},
		searchUser(v,ov){
			if(v != ''){
				this.lawyerList = this.lawyerList.filter(e => e.name.includes(this.searchUser));
			}else{
				this.getlawyerList();
			}
		},
		consultChat : {
			deep: true,
            handler: function(v, ov){
                // console.log('咨询信息:',v);
                let obj = {
                	identity:v.remark.identity,
                	name:v.name,
                	from:v.from,
                	content:v.content,
                	time:v.time
                };
                if(v.type == 'consult_text'){
                	if(this.clientele_id == v.from  || v.remark.clientId == this.clientele_id){
                		if(this.newTime){
		        			var myDate = new Date();
		        			var options={
		        				content: this.timeconvert2(myDate.getTime()),
		                        target: "time",
		        			}
		        			this.mesList.push(options);
		        			this.newTime = false;
		        		}
                		obj = messageConvert(obj);
                		this.mesList.push(obj);
                		// this.getWorkStatistics();
                		this.readMsg();
                		this.scrollToBottom();
                		this.getServeList();
                	}else{
                		//添加用户列表的未读条数
                		for(var i=0;i<this.customer.length;i++){
	                		if(this.customer[i].clienteleId == v.from || v.remark.clientId == this.customer[i].clienteleId){
	                			if(this.customer[i].num){
	                				this.customer[i].num = this.customer[i].num + 1;
	                			}else{
	                				this.customer[i].num = 1;
	                			}
	                		}
	                	}
	                	//将未读的条数添加到numList数组里面，由于判断未读条数。
	                	if(this.numList.length){
	                		let isuser = false;
	                		for(var j=0;j<this.numList.length;j++){
	            				if(this.numList[j].clienteleId == v.from || v.remark.clientId == this.numList[j].clienteleId){
	            					this.numList[j].num = this.numList[j].num + 1;
	            					isuser = true;
	            				}
	            			}
	            			if(!isuser){
	            				let obj ={
	        						clienteleId : v.remark.clientId,
	        						num : 1
	        					};
	        					this.numList.push(obj);
		            		}
	                	}else{
	                		let obj ={
        						clienteleId : v.remark.clientId,
        						num : 1
        					};
        					this.numList.push(obj);
	                	};
	                	this.getServeList();
                	}
                }else if(v.type == 'consult_inviteLawyer'){
                	if(this.clientele_id == v.content.clientId){
                		let objs = {
	                		target :'wait',
	                		msg:'平台正在为您匹配律师'
	                	};
	                	this.mesList.push(objs);
	                	this.scrollToBottom();
                	}
                }else if(v.type == 'consult_lawyerJoin'){
                	if(this.clientele_id == v.content.clientId){
                		this.lawyer_id = v.remark;
                		let objs = {
	                		target :'wait',
	                		msg:'律师已成功加入当前会话'
	                	};
	                	this.mesList.push(objs);
	                	this.scrollToBottom();
                	};
                }else if(v.type == "consult_newClientele"){
                	// this.mesList = [];
                	this.getServeList();
                	// this.getWorkStatistics();
                }else if(v.type == "consult_clienteleLose"){
                	// this.mesList = [];
                	this.getServeList();
                	// this.getWorkStatistics();
                }else if (v.type == "consult_successConsultPay") {
			        let obj2 = {
			          target: 'wait',
			          msg: '客户支付成功!'
			        };
			        this.mesList.push(obj2);
			        this.scrollToBottom();
			        for(var i=0;i<this.customer.length;i++){
                		if(this.customer[i].clienteleId == v.from){
            				this.customer[i].isPay = true;
                		}
                	}
			    }else if (v.type == 'consult_supportStaffJobStat'){
			    	this.workForm.waitLength = v.content.waitLength;
			    	this.workForm.serveCount = v.content.serveCount;
			    }
            }
		}
	},
	filters: {
		timeconvert(t){
			return moment(t).format('YYYY-MM-DD')
		},
		timeconvert1(t){
			return moment(t*1000).format('YYYY-MM-DD HH:mm:ss');
		},
		formatSeconds(t){
			if(t){
				var theTime = parseInt(t);
				var middle = 0;
				var hour = 0;
				if(theTime > 60){
					middle= parseInt(theTime/60);
					theTime = parseInt(theTime%60);
					if(middle> 60){
						hour= parseInt(middle/60);
						middle= parseInt(middle%60);
					}
				}
				if(parseInt(theTime) <10){
					theTime = '0'+theTime;
				}
				if(parseInt(middle) <10){
					middle = '0' + middle;
				}
				if(parseInt(hour) <10){
					hour = '0' + hour;
				}
				var result = hour + ':' + middle+ ':' + theTime;
				return result;
			}else{
				return '00:00:00';
			}
		},
		consultFormInfoTag(value , options){
			for(var i=0;i<options.length;i++){
				if(value == options[i].id){
					return options[i].tag_name;
				}
			}
		}
	},
	components: {
        z_emoji,
        z_fileUpload
    },
    beforeDestroy(){
    	clearInterval(this.timer4);
    	clearInterval(this.timer3);
    },
}
</script>




// WEBPACK FOOTER //
// src/components/consult/customer/consultSession.vue